module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "infoIcon_gray.d98c1f62.svg";